var _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "ionicon",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Calendar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 32,
    x: 48,
    y: 80,
    width: 416,
    height: 384,
    rx: 48
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 296,
    cy: 232,
    r: 24
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 376,
    cy: 232,
    r: 24
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 296,
    cy: 312,
    r: 24
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 376,
    cy: 312,
    r: 24
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 136,
    cy: 312,
    r: 24
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 216,
    cy: 312,
    r: 24
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 136,
    cy: 392,
    r: 24
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 216,
    cy: 392,
    r: 24
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 296,
    cy: 392,
    r: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 32,
    strokeLinecap: "round",
    d: "M128 48v32M384 48v32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 32,
    d: "M464 160H48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.22882d33a30405ea654edd1446f9ea71.svg";
export { ForwardRef as ReactComponent };